<template>
  <div class="container info-container">
    <h1>How to Buy?</h1>
    <h2>Joining the Million Pixel XRP Wall is easier than ever! 🚀</h2>
    <p>
      Now with Xaman wallet integration, getting your spot on the wall takes just a few smooth steps.
      Whether you’re securing a legendary location or just starting your XRP journey, here’s how to do it:
    </p>
    <br>
    <hr>
    <br>
    <p>
      <span class="step">Step 1: Log In with Xaman Wallet</span>
      <br>
      To get started, simply log in using your Xaman wallet.
      It’s fast, secure, and sets your wallet address as the unique owner of your pixel image on the blockchain.
      Once logged in, you can start customizing your Pixel Wall submission right away.
    </p>
    <br>
    <hr>
    <br>
    <p>
      <span class="step">Step 2: Choose Your Pixel Size</span>
      <br>
      Select the area you’d like to own.
      The minimum size is 10x10 (100 pixels), priced at 10 XRP.
      The larger the pixel size, the more visible and impressive your image will be on the wall!
    </p>
    <br>
    <hr>
    <br>
    <p>
      <span class="step">Step 3: Upload Your Image & Link</span>
      <br>
      Upload your image — it can be a photo, logo, artwork, NFT, initials, or anything meaningful to you.
      Add a clickable link (to your X profile, website, video, etc.) that visitors will be directed to when clicking your pixel.
    </p>
    <br>
    <hr>
    <br>
    <p>
      <span class="step">Step 4: Add Contact Info</span>
      <br>
      Leave your email (or other contact method) so our team can reach you if needed.
      You’ll also receive a confirmation email with a unique Order ID once your submission is received.
    </p>
    <br>
    <hr>
    <br>
    <p>
      <span class="step">Step 5: Make Payment with Xaman Wallet</span>
      <br>
      Complete your order with just a few taps using your Xaman wallet.
      Your payment will be recorded directly on the blockchain and linked to your wallet.
      That wallet address will serve as proof of ownership for your spot on the Pixel Wall.
    </p>
    <br>
    <hr>
    <br>
    <p>
      <strong>Bonus Info:</strong><br>
      All images are posted automatically and should appear on the Pixel Wall right away after payment.<br>
      If you don’t see your image immediately — try a good old refresh or clear your browser cookies.<br><br>
      You’re always welcome to update your image anytime by simply logging into your Pixel Wall profile.
      Just pay a small extra fee, and your new image will be automatically updated on your spot.<br><br>
      You can view your active orders and ownership directly through your logged-in Pixel Wall profile.<br><br>
      Special central “Buy It Now” zones are available for premium visibility (minimum 5x5 area).
      For those or other custom requests, reach out directly through our X profile:
    </p>

    <p>
      <a :href="sellerXurl" target="_blank">
        <font-awesome-icon :icon="['fab', 'x-twitter']" />
        <span> {{ sellerXname }}</span>
      </a>
    </p>

    <p>
      <br>
      <strong>This is the official address for payments: {{ sellerAddress }}</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: 'HowToBuyPage',
  data() {
    return {
      sellerXurl: process.env.VUE_APP_SELLER_X_URL,
      sellerXname: process.env.VUE_APP_SELLER_X_NAME,
      sellerAddress: process.env.VUE_APP_SELLER_XRPL_ADDRESS
    }
  }
}
</script>

<style scoped>
</style>
